import { render, staticRenderFns } from "./DisOrder.vue?vue&type=template&id=86c613d4&scoped=true&"
import script from "./DisOrder.vue?vue&type=script&lang=js&"
export * from "./DisOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c613d4",
  null
  
)

component.options.__file = "DisOrder.vue"
export default component.exports